import { Component, OnInit, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router'
import { ManageService } from '../../../../../services/manage.service';
import { Subject } from 'rxjs';
import { CSPModifySubscriptionResponse, CSPSubscriptions, SupportedBillingCycle, WGSModifySubscriptionResponse, WGSubscriptionModel } from '../../../../../models/csp.model';
import { AnnuityItemsViewModel } from '../../../../../models/annuity-view.model';
import { MatDialog } from '@angular/material/dialog';
import { ADKDetailsViewModel } from '../../../../../models/adk-details-view.model';
import { CommonService } from '../../../../../services';
import { takeUntil } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { DatePipe } from '@angular/common';
import { PanelService } from '../../../../../services/panel.service';
import { __values } from 'tslib';
import { ConfirmWGSCreateComponent } from '../../../../../popup-collection/confirm-wgs-create/confirm-wgs-create.component';
import { FinishWGSCreateComponent } from '../../../../../popup-collection/finish-wgs-create/finish-wgs-create.component';

@Component({
  selector: 'app-confirm-wgs-products',
  templateUrl: './confirm-wgs-product.component.html',
  styleUrls: ['./confirm-wgs-product.component.css'],
  providers: [DatePipe]
})

export class ConfirmWGSProductsComponent implements OnInit, OnDestroy {
  loadContent: boolean = false;
  tenantId: string;
  productType: string;
  purchase: string;
  details: ADKDetailsViewModel;
  mpnList: string[];
  SupportedBillingCycleTypes: Array<string> = [];
  supportedBillingCycleTypesList: SupportedBillingCycle[] = [];
  skuList: Array<string> = [];
  billingFrequencyList: SupportedBillingCycle[];
  showMpnIdloading: boolean;
  azureRiMPNControl: FormControl;
  ngUnsubscribe: Subject<void> = new Subject<void>();


  subscriptionItemsPendingList: AnnuityItemsViewModel[] = [];
  azureSubscriptionItemsPendingList: AnnuityItemsViewModel[] = [];

  //Subscription
  // pendingRowConfirmStatus = false;
  originalBaseQty: string[];
  originalBaseActive: boolean[];
  totalPriceChange = 0;
  pendingTotal = 0;
  activeTotal = '0';
  // changeSubscriptionAmount: number;
  confirmAnnuityItemSubscription: WGSubscriptionModel;
  confirmSubscriptions: WGSubscriptionModel[];
  finishSubscriptions: CSPModifySubscriptionResponse[];
  poReference = '';
  CompanyName = '';
  AttentionRef = '';
  NoMPNText = '';
  Email = '';
  AddressLine1 ='';
  AddressLine2='';
  AddressLine3='';
  City ='';
  State ='';
  PostCode = '';
  PhoneNumber = '';

  public subsForViewEndDates: CSPSubscriptions[]

  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private dialog: MatDialog,
    private manageService: ManageService,
    public commonService: CommonService,
    public calendar: NgbCalendar,
    public sidenavService: PanelService
  ) {
  }

  async ngAfterViewInit(): Promise<void> {
    await this.commonService.waitForElm('#levelOne');
    //Here it's check widt available then width other wise it's return 0
    let addWGSProduct = $('#addWGSProduct').width()?$('#addWGSProduct').width():0;
    let addProductSideBar = $('#addProductSideBar').width()?$('#addProductSideBar').width():0;
    $('#levelOne').animate({ scrollLeft: 1232 + addWGSProduct + addProductSideBar }, 400);
  }

  ngOnInit() {
    this.loadContent = true;

    this.activatedRoute.parent.parent.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(params => this.tenantId = params.get('tenantId'));
    this.activatedRoute.parent.paramMap.pipe(takeUntil(this.ngUnsubscribe)).subscribe(params => this.productType = params.get('productType'));

    this.manageService.getCurrentWGSContractResellerId
        .pipe(takeUntil(this.ngUnsubscribe))
        .subscribe(resellerId => {
          if (resellerId) {
            this.tenantId = resellerId;
          }
    });
    
    this.getPendingSubscription();
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  close() {
    this.manageService.monitorPendingWGSSubscriptions([]);
    this.manageService.monitorPendingAzureRi([]);
    this.manageService.monitorPendingSubscriptions([]);
    this.manageService.monitorPendingSoftware([]);
    this.router.navigateByUrl("/manageSubscriptions/manageAnnuities/WGS");
    $('#levelOne').animate({ scrollLeft: $('#managewgs').width() + 505 }, 400);
  }

  getPendingSubscription(): void {
    this.manageService.currentPendingWGSSubscriptions.pipe(takeUntil(this.ngUnsubscribe)).subscribe((model: AnnuityItemsViewModel[]) => {
      this.subscriptionItemsPendingList = [ ...model ];

      this.totalPriceChange = this.pendingTotal = 0;
      if (this.subscriptionItemsPendingList.length > 0) {
        this.totalPriceChange = this.pendingTotal = this.calculateTotalPriceChange();

      }
    },
      (error: any) => {
        console.error(error);
        this.loadContent = true;
      });

  }

  calculateTotalPriceChange(): number {
    let totalPrice = 0;
    this.subscriptionItemsPendingList.forEach(subscription => {
      totalPrice += this.commonService.toNumber(subscription.quantity) * this.commonService.toNumber(subscription.itemPrice.replace('$', '').replace(',', ''));
    });
    return totalPrice;
  }

  public removeSubscriptionPendingItem(index: number): void {
    this.subscriptionItemsPendingList.splice(index, 1);
    this.manageService.monitorPendingSubscriptions(this.subscriptionItemsPendingList);
    if (!this.subscriptionItemsPendingList?.length) {
      this.close();
    }
  }

  confirmSubscription(): void {
    
    this.confirmSubscriptions = [];
    this.subscriptionItemsPendingList.forEach(annuityItem => {
      
      this.confirmAnnuityItemSubscription = {} as WGSubscriptionModel;
      this.confirmAnnuityItemSubscription = {
        tenantId: this.tenantId,
        mpnId: this.commonService.parseNPM(annuityItem.mpn),
        subscriptionId: '',
        subscriptionDescription: annuityItem.subscriptionDescription,
        customerReference: this.poReference,
        stockDescription: annuityItem.description,
        parentSubscriptionId: '',
        stockCode: annuityItem.stockCode,
        qty: annuityItem.quantity,
        status: '',
        ownerEmail: annuityItem.ownerEmail,
        price: annuityItem.itemPrice,
        totalPrice: annuityItem.totalPrice.toString(),
        billingFrequency: annuityItem.billingFrequency,
        stockGroup: annuityItem.stockGroup,
        offerId: annuityItem.offerId,
        chargeType: annuityItem.chargeType,
        unitCost_RRP: Number(annuityItem.itemRRPrice.replace(/[^0-9.-]+/g,"")).toString(),
        AttentionRef : this.AttentionRef,       
        CompanyName :this.CompanyName,
        Email: this.Email,
        AddressLine1:this.AddressLine1,
        AddressLine2:this.AddressLine2,
        AddressLine3:this.AddressLine3,
        City:this.City,
        State:this.State,
        PostCode:this.PostCode,
        PhoneNumber:this.PhoneNumber
      };

      // tenant id is reseller id ?
      this.confirmSubscriptions.push(this.confirmAnnuityItemSubscription);
    });


    if (this.confirmSubscriptions.length) {
      this.openConfirmPendingModal();
    } else {
      this.commonService.implementToast('There is no pending subscription to confirm', 'Error');
    }
  }

  openConfirmPendingModal(): void {
  
    const dialogRef = this.dialog.open(ConfirmWGSCreateComponent, {
      width: '650px',
      data: { totalPriceChange: this.totalPriceChange, pendingTotal: this.pendingTotal, confirmSubscriptions: this.confirmSubscriptions }
    });

    dialogRef.afterClosed().subscribe(result => {

      if (result) {
        this.subscriptionItemsPendingList = [];
        this.azureSubscriptionItemsPendingList = [];
        this.totalPriceChange = 0;
        this.pendingTotal = 0;
        this.subscriptionItemsPendingList = [];
        this.manageService.monitorPendingWGSSubscriptions([]);
        this.manageService.monitorPendingAzureRi([]);
        this.manageService.monitorPendingSubscriptions([]);
        this.manageService.monitorPendingSoftware([]);
        this.manageService.monitorSubscriptionConfirmValue('Update');
        this.manageService.refetchWGSItemsView$.next();
        this.router.navigateByUrl("/manageSubscriptions/manageAnnuities/WGS");
        $('#levelOne').animate({ scrollLeft: 250 }, 400);          
      }
      
      // if (result) {
      //   this.poReference = result.poReference;     
      //   this.AttentionRef = result.AttentionRef;
      //   this.CompanyName = result.CompanyName;  
      //   this.Email = result.Email;
      //   this.AddressLine1 =result.AddressLine1;
      //   this.AddressLine2 =result. AddressLine2;
      //   this.AddressLine3 = result. AddressLine3;
      //   this.City = result.City ;
      //   this.State = result.State;
      //   this.PostCode =result.PostCode ;
      //   this.PhoneNumber = result.PhoneNumber;
      //   this.loadContent = false;
      //   if (this.confirmSubscriptions.length) {
         
      //     this.confirmSubscriptions.map(item => {
      //       item.customerReference = this.poReference;
      //       item.AttentionRef = this.AttentionRef;
      //       item.CompanyName = this.CompanyName;
      //       item.Email = this.Email;
      //       item.AddressLine1 = this.AddressLine1;
      //       item.AddressLine2 = this.AddressLine2;
      //       item.AddressLine3 = this.AddressLine3;
      //       item.City = this.City;
      //       item.State = this.State;
      //       item.PostCode = this.PostCode;
      //       item.PhoneNumber = this.PhoneNumber;          
      //     });

      //     this.addWGSProduct();

      //   }
      // }
    });
  }

  addWGSProduct(): void {
  
    this.manageService.addWGSProduct(this.confirmSubscriptions).subscribe((res: WGSModifySubscriptionResponse[]) => {
      if (res.length) {
        this.finishSubscriptions = res;
        this.loadContent = true;
        const dialogRefFinish = this.dialog.open(FinishWGSCreateComponent, {
          width: '900px',
          data: { finishSubscriptions: this.finishSubscriptions },
          disableClose: true
        });

        dialogRefFinish.afterClosed().subscribe(() => {
          if (res?.every(i => i?.isUpdateSuccessful)) {
            this.subscriptionItemsPendingList = [];
            this.azureSubscriptionItemsPendingList = [];
            this.totalPriceChange = 0;
            this.pendingTotal = 0;
            this.subscriptionItemsPendingList = [];
            this.manageService.monitorPendingWGSSubscriptions([]);
            this.manageService.monitorPendingAzureRi([]);
            this.manageService.monitorPendingSubscriptions([]);
            this.manageService.monitorPendingSoftware([]);
            this.manageService.monitorSubscriptionConfirmValue('Update');
            this.manageService.refetchWGSItemsView$.next();
            this.router.navigateByUrl("/manageSubscriptions/manageAnnuities/WGS");
            $('#levelOne').animate({ scrollLeft: 250 }, 400);          
          } else {
          }
        });
      } else {
        this.commonService.implementToast('Something went wrong while cloning', 'Error');
      }
    });
  }

  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

}
